<div class="row justify-content-lg-center lightCremeBackground pt-5" style="padding-bottom:70px">
    <div class="row text-align-start" style="width:1000px; text-align: center;">
        <h3 class="Caecilia76BoldItalic greenText" style="display:inline; font-size:28px; margin-bottom:1.5%; ">Our
            Knowledge Your Growth</h3>
    </div>

    <div class="row  justify-content-lg-center" style="padding-left:20px">
        <div *ngIf="this.featuredBlog1ImageName != ''" class="blogOuter" style="cursor:pointer;margin-right:60px">
            <div (click)="this.GoToBlogInNewTab(this.featuredBlog1ItemAlias)" style="text-align: left">
                <img class="blogImage" src="{{this.featuredBlog1ImageName}}" alt="fertilizer image">
                <h5 class="DIN2014Regular blueText text-center"
                    style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog1Title"></h5>
                <h5 class="DIN2014Regular text-center line-clamp"
                    style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog1Summary"></h5>
                <a href="">
                    <h5 class="DIN2014Regular text-center"
                        style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                        READ ARTICLE ></h5>
                </a>
            </div>
        </div>
        <div *ngIf="this.featuredBlog2ImageName != ''" class="blogOuter" style="cursor:pointer;margin-right:60px">
            <div (click)="this.GoToBlogInNewTab(this.featuredBlog2ItemAlias)" style="text-align: left">
                <img class="blogImage" src="{{this.featuredBlog2ImageName}}" alt="fertilizer blogImage">
              <h5 class="DIN2014Regular blueText text-center"
                    style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog2Title"></h5>
                <h5 class="DIN2014Regular text-center line-clamp"
                    style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog2Summary"></h5>
                <a href="">
                    <h5 class="DIN2014Regular text-center"
                        style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                        READ ARTICLE ></h5>
                </a>
            </div>
        </div>
        <div *ngIf="this.featuredBlog3ImageName != ''" class="blogOuter" style="cursor:pointer;margin-right:20px">
            <div (click)="this.GoToBlogInNewTab(this.featuredBlog3ItemAlias)" style="text-align: left">
                <img class="blogImage" src="{{this.featuredBlog3ImageName}}" alt="fertilizer image">
              <h5 class="DIN2014Regular blueText text-center"
                    style="margin-top:20px; font-size:21px; font-weight:600; letter-spacing: .32px;" [innerHTML]="this.featuredBlog3Title"></h5>
                <h5 class="DIN2014Regular text-center line-clamp"
                    style="font-size:19px; line-height: 28px; font-weight:400; letter-spacing: .38px;" [innerHTML]="this.featuredBlog3Summary"></h5>
                <a href="">
                    <h5 class="DIN2014Regular text-center"
                        style="margin-top:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                        READ ARTICLE ></h5>
                </a>
            </div>
        </div>
    </div>
</div>
